import { createStore } from 'vuex';
import axios from 'axios';
import createPersistedState from 'vuex-persistedstate';

import booking from './modules/booking';
import func from './modules/func';
import more from './modules/more';
import service from './modules/service';
import trade from './modules/trade';
import user from './modules/user';

export default createStore({
  state: {
    lang: 'tw',
    hno: 101,
  },
  mutations: {
    SET_LANG(state, lang) {
      state.lang = lang;
    },
  },
  actions: {
    sendEmail(
      _,
      {
        from = 'KH@kloudhotel.com.tw',
        to,
        subject,
        bodyHtmlContent,
        bcc = [],
        bodyTextContent = '',
      },
    ) {
      return new Promise((resolve, reject) => {
        axios
          .post('/MailTransfer', {
            from,
            to,
            bcc,
            subject,
            bodyHtmlContent,
            bodyTextContent,
          })
          .then((resp) => resolve(resp))
          .catch((err) => reject(err));
      });
    },
  },
  modules: {
    booking,
    func,
    more,
    service,
    trade,
    user,
  },
  plugins: [
    createPersistedState({
      key: 'kloud-hotel',
    }),
  ],
});
